// extracted by mini-css-extract-plugin
export var button = "commentsSection-module--button--eb69b";
export var comment = "commentsSection-module--comment--ea563";
export var image = "commentsSection-module--image--087fc";
export var name = "commentsSection-module--name--a78ac";
export var quote = "commentsSection-module--quote--6ed96";
export var subQuote = "commentsSection-module--subQuote--d3517";
export var wrapper = "commentsSection-module--wrapper--f6c40";